import { RouteSettings } from "./RouteSettings";

export default RouteSettings;
